











 










const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ToggleSummaryEmailMutation_team",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sendSummaryEmail",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ToggleSummaryEmailSuccess",
  "abstractKey": null
};

(node ).hash = "31b4182b23d7f0adfa092959ea6ffeb9";

export default node;
